import { getFetchedDataPayload } from '../../../../utils/fetched-data/get-fetched-data-payload';
import { getShowtimeById } from '../../../browsing/selectors/showtimes/get-showtime-by-id';
import { orderDomainStore } from '../../store';
export const getOrderRelatedShowtimeById = (id) => {
    return getFetchedDataPayload(orderDomainStore.data.showtimesById[id]) || getShowtimeById(id);
};
